import { Component, OnInit, Input, Output, OnChanges, OnDestroy, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BannerType } from '@enums';
import { BannerMessage } from '@model';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { SubSink } from 'subsink';
import * as fromHelpStore from '@appStore/help';

@Component({
    selector: 'app-contextual-system-message',
    templateUrl: './contextual-system-message.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContextualSystemMessageComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  contextualMessages: BannerMessage[];

  contextualMessagesDisplay: BannerMessage[];
  routeSubscription: Subscription;
  currentUrl = '';
  selectedTab = '';

  private subs = new SubSink();
  bannerTypeEnum = BannerType;


  constructor(private router: Router, 
    private store: Store<fromHelpStore.State>,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.contextualMessagesDisplay = [] as BannerMessage[];

    if (this.router) {
      this.currentUrl = window.location.pathname;
      this.filterItems(); 

      this.subs.sink = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(routeEvent => {
          if (routeEvent && routeEvent['url'] && routeEvent['url'] !== this.currentUrl) {
            this.currentUrl = routeEvent['url'];
            this.filterItems();
            this.changeDetectorRef.detectChanges();
          }
        });


        // Fetch SelectedTab, set by directive: appSelectedTab
        this.subs.sink = this.store
        .select(fromHelpStore.getSelectedTab)
        .pipe(filter(x => !!x))
        .subscribe(selectedTab => {
          this.selectedTab = selectedTab;
          this.filterItems();
          // Force the view to update
          this.changeDetectorRef.detectChanges();
        });
    }
  }

  ngOnChanges() {
    if(this.currentUrl) {
      this.filterItems();
      // Force the view to update
      this.changeDetectorRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  filterItems() {
    if (this.contextualMessages) {
      this.contextualMessagesDisplay = this.contextualMessages.filter(this.isRegMatch);
    } else {
      this.contextualMessagesDisplay = [] as BannerMessage[];
    }
  }

  isRegMatch = (ci: BannerMessage): boolean => {
    let qParamMatch = false;
    let result = false;
    let routes = ci.route.split(':'); // More than one route to match for context-info

    for (let i = 0; i < routes.length; i++) {
      let route = routes[i];
      let parts = route.split('?tab=');
      if (parts.length > 1) {
        let qParam = parts[1];
        if (this.selectedTab === qParam) {
          qParamMatch = true;
        } else {
          qParamMatch = false;
        }
      } else {
        qParamMatch = true;
      }
      let pattern = parts[0].replace('/', '\\/');
      // let  fetch $xxx params
      let regEx = new RegExp(pattern + '\\/?$');
      result = regEx.test(this.currentUrl) && qParamMatch;
      if (result) {
        break; // Exit loop
      }
    }

    return result;
  };
}
